'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var FONTS = Object.freeze({
  PRIMARY: 'Labil Grotesk'
});
var COLORS = Object.freeze({
  PRIMARY: '#528bef',
  // OCEAN
  SECONDARY: '#22222d',
  // BLACK_100

  BLACK_100: '#22222d',
  BLACK_50: '#3c3d47',
  WHITE: '#ffffff',
  GREY_BLUE: '#898e97',
  GREY_400: '#70747d',
  GREY_200: '#d9d9d9',
  GREY_100: '#eeeff2',
  GREY_50: '#fcfcfe',
  GREY: '#ececec',
  ROSE: '#f46565',
  ROSE_300: '#feeaea',
  ROSE_500: '#f46565',
  RED: '#e83938',
  LILAC_PURPLE: '#7b77ff',
  LILAC_PURPLE_300: '#e0dfff',
  LILAC_PURPLE_500: '#7b77ff',
  AQUA: '#179cb0',
  OCEAN: '#528bef',
  DEEP_SEA: '#23255d',
  PAPAYA: '#e27815',
  PAPAYA_300: '#ffecdb',
  PASSION_FRUIT: '#f0bc3f',
  PASSION_FRUIT_300: '#ffeebe',
  CONFIRM: '#2ea920',
  ERROR: '#e83938',
  PINK: '#fff3ee',
  DARK_PINK: '#FA9BFA'
});
var TEXT_COLORS = Object.freeze({
  HEADING: '#272423',
  DEFAULT: '#3c3d47',
  // black-50
  INACTIVE: '#90949c',
  // inactive or placeholder
  TABLE_HEAD: '#313336'
});
var FONT_SIZES = {
  H1: '32px',
  H2: '28px',
  H3: '24px',
  H4: '20px',
  LEAD: '18px',
  DEFAULT: '15px',
  SMALL: '13px'
};
var WALLET_COLORS = {
  WELLNESS: COLORS.PAPAYA_300,
  FAMILY: COLORS.LILAC_PURPLE_300,
  COMMUTER: COLORS.PASSION_FRUIT_300,
  REWARDS: COLORS.GREY_100
};
var PIE_CHART_COLORS = ['#4967E5', '#5E85FE', '#FA9BFA', '#FFE577', '#56CAEC'];

exports.COLORS = COLORS;
exports.FONTS = FONTS;
exports.FONT_SIZES = FONT_SIZES;
exports.PIE_CHART_COLORS = PIE_CHART_COLORS;
exports.TEXT_COLORS = TEXT_COLORS;
exports.WALLET_COLORS = WALLET_COLORS;
